// import axios from "axios";
// import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import "../../assets/css/Loader.css";
// // Assuming ApiUrl is defined in a separate file like this:
// import ApiUrl from "./../Environment/ApiUrl";
// import { useToast } from "../Toast/ToastContext"; // Import useToast hook
// // For PDF export
// import { jsPDF } from "jspdf";
// import autoTable from "jspdf-autotable";

// // For Excel export
// import * as XLSX from "xlsx";

// // For toast notifications (assuming you have a toast library like react-toastify or similar)
// // If you don't have one, you'll need to install and configure it, or remove toast calls.
// // import { toast } from 'react-toastify'; // Example import, adjust based on your library

// function SalesExpense() {
//   const [responseData, setResponseData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();
//   const toast = useToast();
//   // Pagination state
//   const [currentPage, setCurrentPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(10);
//   const [showAllItems, setShowAllItems] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");

//   useEffect(() => {
//     fetchData();
//   }, []);

//   const fetchData = async () => {
//     try {
//       setLoading(true);
//       const response = await axios.get(`${ApiUrl}/Api/sales_vs_expense.php`);
//       console.log("Response from sales_vs_expense:", response.data);
//       setResponseData([...(response.data?.data || [])].reverse());
//     } catch (error) {
//       console.error("Error fetching data:", error.message);
//       setResponseData([]); // Set to empty array on error
//     } finally {
//       // Ensure loading is set to false even if there's an error
//       setTimeout(() => {
//         setLoading(false);
//       }, 500);
//     }
//   };

//   // Filter data based on search term
//   const filteredData = responseData.filter((item) => {
//     const searchLower = searchTerm.toLowerCase();
//     return (
//       (item.date && item.date.toLowerCase().includes(searchLower)) ||
//       (item.sales_total &&
//         item.sales_total.toString().toLowerCase().includes(searchLower)) ||
//       (item.expense_total &&
//         item.expense_total.toString().toLowerCase().includes(searchLower))
//     );
//   });

//   // Calculate pagination values
//   const totalItems = filteredData.length;
//   const totalPages = showAllItems ? 1 : Math.ceil(totalItems / itemsPerPage);

//   // Get current items for pagination
//   const currentItems = showAllItems
//     ? filteredData
//     : filteredData.slice(
//         (currentPage - 1) * itemsPerPage,
//         currentPage * itemsPerPage
//       );

//   const handlePageChange = (page) => {
//     if (page < 1 || page > totalPages) return;
//     setCurrentPage(page);
//   };

//   const handleItemsPerPageChange = (e) => {
//     const value = e.target.value;
//     if (value === "All") {
//       setShowAllItems(true);
//       setCurrentPage(1);
//     } else {
//       setShowAllItems(false);
//       setItemsPerPage(Number(value));
//       setCurrentPage(1); // Reset to first page when changing items per page
//     }
//   };

//   const renderPageNumbers = () => {
//     const pages = [];
//     const maxVisiblePages = 2; // Number of page buttons to show

//     // Calculate range of pages to display
//     let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
//     let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

//     // Adjust if we're at the beginning or end
//     if (endPage - startPage + 1 < maxVisiblePages) {
//       startPage = Math.max(1, endPage - maxVisiblePages + 1);
//     }

//     // First page and ellipsis
//     if (startPage > 1) {
//       pages.push(
//         <li
//           key={1}
//           className={`page-item ${currentPage === 1 ? "active" : ""}`}
//         >
//           <button className="page-link" onClick={() => handlePageChange(1)}>
//             1
//           </button>
//         </li>
//       );
//       if (startPage > 2) {
//         pages.push(
//           <li key="start-ellipsis" className="page-item disabled">
//             <span className="page-link">...</span>
//           </li>
//         );
//       }
//     }

//     // Visible page numbers
//     for (let i = startPage; i <= endPage; i++) {
//       pages.push(
//         <li
//           key={i}
//           className={`page-item ${currentPage === i ? "active" : ""}`}
//         >
//           <button className="page-link" onClick={() => handlePageChange(i)}>
//             {i}
//           </button>
//         </li>
//       );
//     }

//     // Last page and ellipsis
//     if (endPage < totalPages) {
//       if (endPage < totalPages - 1) {
//         pages.push(
//           <li key="end-ellipsis" className="page-item disabled">
//             <span className="page-link">...</span>
//           </li>
//         );
//       }
//       pages.push(
//         <li
//           key={totalPages}
//           className={`page-item ${currentPage === totalPages ? "active" : ""}`}
//         >
//           <button
//             className="page-link"
//             onClick={() => handlePageChange(totalPages)}
//           >
//             {totalPages}
//           </button>
//         </li>
//       );
//     }

//     return pages;
//   };

//   const handleSalesExpense = (date) => {
//     navigate(`/add-sales-vs-expense/${date}`);
//   };

//   // Function to format date to dd-mm-yyyy
//   const formatDate = (dateString) => {
//     if (!dateString) return "";
//     try {
//       const date = new Date(dateString);
//       if (isNaN(date.getTime())) {
//         return dateString; // Return original if invalid
//       }
//       const day = String(date.getDate()).padStart(2, "0");
//       const month = String(date.getMonth() + 1).padStart(2, "0");
//       const year = date.getFullYear();
//       return `${day}-${month}-${year}`;
//     } catch (error) {
//       return dateString; // Return original if parsing fails
//     }
//   };

//   // --- Export Functions ---

//   // Print function
//   const handlePrint = () => {
//     const printWindow = window.open("", "_blank");
//     const printContent = `
//     <!DOCTYPE html>
//     <html>
//     <head>
//       <title>Sales vs Expense Report</title>
//       <style>
//         body { font-family: Arial, sans-serif; margin: 20px; }
//         h1 { text-align: center; color: #333; margin-bottom: 30px; }
//         table { width: 100%; border-collapse: collapse; margin-top: 20px; }
//         th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
//         th { background-color: #f2f2f2; font-weight: bold; }
//         tr:nth-child(even) { background-color: #f9f9f9; }
//         .print-date { text-align: right; margin-bottom: 20px; font-size: 12px; }
//         @media print {
//           body { margin: 0; }
//           .no-print { display: none; }
//         }
//       </style>
//     </head>
//     <body>
//       <div class="print-date">Generated on: ${new Date().toLocaleString()}</div>
//       <h1>Sales vs Expense Report</h1>
//       <table>
//         <thead>
//           <tr>
//             <th>S.No</th>
//             <th>Date</th>
//             <th>Sales Total</th>
//             <th>Expense Total</th>
//           </tr>
//         </thead>
//         <tbody>
//           ${currentItems // Use currentItems for printing the currently displayed data
//             .map(
//               (item, index) => `
//             <tr>
//               <td>${(currentPage - 1) * itemsPerPage + index + 1}</td>
//               <td>${formatDate(item.date) || ""}</td>
//               <td>₹ ${item.sales_total || "0"}</td>
//               <td>₹ ${item.expense_total || "0"}</td>
//             </tr>
//           `
//             )
//             .join("")}
//         </tbody>
//       </table>
//       <div style="margin-top: 30px; text-align: center; font-size: 12px;">
//         Total Records: ${filteredData.length}
//       </div>
//     </body>
//     </html>
//   `;

//     printWindow.document.write(printContent);
//     printWindow.document.close();
//     printWindow.focus();
//     setTimeout(() => {
//       printWindow.print();
//       printWindow.close();
//     }, 250);

//      toast.success("Print dialog opened!", 2000, "topRight");
//   };

//   // PDF Export function
//   const exportPDF = () => {
//     const doc = new jsPDF();

//     // Add title
//     doc.setFontSize(18);
//     doc.text("Sales vs Expense Report", 14, 22);

//     // Add generation date
//     doc.setFontSize(10);
//     doc.text(`Generated on: ${new Date().toLocaleString()}`, 14, 35);

//     // Prepare table data
//     const tableColumn = ["S.No", "Date", "Sales Total", "Expense Total"];

//     const tableRows = currentItems.map((item, index) => [
//       (currentPage - 1) * itemsPerPage + index + 1,
//       formatDate(item.date) || "",
//       `₹${item.sales_total || "0"}`,
//       `₹${item.expense_total || "0"}`,
//     ]);

//     // Add table
//     autoTable(doc, {
//       head: [tableColumn],
//       body: tableRows,
//       startY: 45,
//       styles: { fontSize: 8 },
//       headStyles: { fillColor: [66, 139, 202] },
//       margin: { top: 45 },
//     });

//     // Add footer with total count
//     const finalY = doc.lastAutoTable.finalY || 45;
//     doc.setFontSize(10);
//     doc.text(`Total Records: ${filteredData.length}`, 14, finalY + 15);

//     // Save the PDF
//     doc.save(`sales-vs-expense-${new Date().toISOString().split("T")[0]}.pdf`);
//        toast.success("PDF exported successfully!", 3000, "topRight");
//   };

//   const copyToClipboard = () => {
//     try {
//       const headers = ["S.No", "Date", "Sales Total", "Expense Total"];

//       const rows = (currentItems || []).map((item, index) => [
//         (currentPage - 1) * itemsPerPage + index + 1,
//         formatDate(item.date) || "",
//         item.sales_total || "0",
//         item.expense_total || "0",
//       ]);

//       const formattedText = [headers, ...rows]
//         .map((row) => row.map((field) => `"${field}"`).join("\t"))
//         .join("\n");

//       if (navigator.clipboard && navigator.clipboard.writeText) {
//         navigator.clipboard
//           .writeText(formattedText)
//           .then(() => {
//             toast.success("Data copied to clipboard!", 3000, "topRight");
//             alert("Data copied to clipboard!"); // Fallback if no toast library
//           })
//           .catch((err) => {
//             console.error("Clipboard API failed:", err);
//             fallbackCopy(formattedText);
//           });
//       } else {
//         fallbackCopy(formattedText);
//       }
//     } catch (error) {
//       console.error("Unexpected error copying to clipboard:", error);
//       // toast.error("Failed to copy data", 3000, "topRight");
//       alert("Failed to copy data"); // Fallback if no toast library
//     }
//   };

//   const fallbackCopy = (text) => {
//     try {
//       const textArea = document.createElement("textarea");
//       textArea.value = text;
//       textArea.style.position = "fixed";
//       textArea.style.top = 0;
//       textArea.style.left = 0;
//       textArea.style.width = "2em";
//       textArea.style.height = "2em";
//       textArea.style.padding = 0;
//       textArea.style.border = "none";
//       textArea.style.outline = "none";
//       textArea.style.boxShadow = "none";
//       textArea.style.background = "transparent";

//       document.body.appendChild(textArea);
//       textArea.focus();
//       textArea.select();

//       const successful = document.execCommand("copy");
//       document.body.removeChild(textArea);

//       if (successful) {
//         toast.success("Data copied to clipboard!", 3000, "topRight");
//         alert("Data copied to clipboard!"); // Fallback if no toast library
//       } else {
//         toast.error("Failed to copy data", 3000, "topRight");
//         alert("Failed to copy data"); // Fallback if no toast library
//       }
//     } catch (err) {
//       console.error("Fallback copy failed:", err);
//       toast.error("Failed to copy data", 3000, "topRight");
//       alert("Failed to copy data"); // Fallback if no toast library
//     }
//   };

//   // CSV Export function
//   const exportCSV = () => {
//     const headers = ["S.No", "Date", "Sales Total", "Expense Total"];

//     const csvContent = [
//       headers.join(","),
//       ...currentItems.map((item, index) =>
//         [
//           (currentPage - 1) * itemsPerPage + index + 1,
//           `"${formatDate(item.date)}"`,
//           item.sales_total || "0",
//           item.expense_total || "0",
//         ].join(",")
//       ),
//     ].join("\n");

//     const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
//     const link = document.createElement("a");

//     if (link.download !== undefined) {
//       const url = URL.createObjectURL(blob);
//       link.setAttribute("href", url);
//       link.setAttribute(
//         "download",
//         `sales-vs-expense-${new Date().toISOString().split("T")[0]}.csv`
//       );
//       link.style.visibility = "hidden";
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);
//     }
//   };

//   // Excel Export function
//   const exportExcel = () => {
//     const headers = ["S.No", "Date", "Sales Total", "Expense Total"];

//     const excelData = [
//       headers,
//       ...currentItems.map((item, index) => [
//         (currentPage - 1) * itemsPerPage + index + 1,
//         formatDate(item.date) || "",
//         item.sales_total || "0",
//         item.expense_total || "0",
//       ]),
//     ];

//     const worksheet = XLSX.utils.aoa_to_sheet(excelData);

//     // Set column widths
//     const colWidths = [
//       { wch: 8 }, // S.No
//       { wch: 15 }, // Date
//       { wch: 15 }, // Sales Total
//       { wch: 15 }, // Expense Total
//     ];
//     worksheet["!cols"] = colWidths;

//     // Style the header row (optional, requires more advanced XLSX usage or a library that supports it easily)
//     // For basic styling like bold and fill, you'd typically need to apply cell styles.
//     // This example focuses on basic export. If you need advanced styling, consider a more robust solution or add more XLSX features.

//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, "Sales vs Expense");

//     // Generate filename with current date
//     const fileName = `sales-vs-expense-${
//       new Date().toISOString().split("T")[0]
//     }.xlsx`;
//     XLSX.writeFile(workbook, fileName);
//   };

//   return (
//     <>
//       {loading && (
//         <div className="loading-overlay">
//           <div className="loading-message">
//             <div className="loadinggif"></div>
//           </div>
//         </div>
//       )}

//       <div className="container-fluid">
//         <h6 className="card-title m-2">Sales Vs Expense</h6>

//         {/* Customer List Card */}
//         <div className="card shadow-sm mb-5">
//           <div className="card-body">
//             <div className="d-flex justify-content-between align-items-center mb-3">
//               {/* Left side - Show per page */}
//               <div className="d-flex">
//                 <label className="form-label text-dark mt-2">Show : </label>
//                 <div>
//                   <select
//                     className="form-control mx-2"
//                     onChange={handleItemsPerPageChange}
//                     value={showAllItems ? "All" : itemsPerPage}
//                   >
//                     <option value="All">All</option>
//                     {[5, 10, 20, 100, 200, 500, 1000].map((pageSize) => (
//                       <option key={pageSize} value={pageSize}>
//                         {pageSize}
//                       </option>
//                     ))}
//                   </select>
//                 </div>
//               </div>

//               {/* Center - Export/Action buttons */}
//               <div className="d-flex justify-content-center">
//                 <button
//                   className="btn btn-sm btn-info text-white mx-1"
//                   onClick={handlePrint}
//                 >
//                   Print
//                 </button>
//                 <button
//                   className="btn btn-sm btn-info text-white mx-1"
//                   onClick={exportPDF}
//                 >
//                   PDF
//                 </button>
//                 <button
//                   className="btn btn-sm btn-info text-white mx-1"
//                   onClick={copyToClipboard}
//                 >
//                   Copy
//                 </button>
//                 <button
//                   className="btn btn-sm btn-info text-white mx-1"
//                   onClick={exportCSV}
//                 >
//                   CSV
//                 </button>
//                 <button
//                   className="btn btn-sm btn-info text-white mx-1"
//                   onClick={exportExcel}
//                 >
//                   Excel
//                 </button>
//               </div>

//               {/* Right side - Search */}
//               <div className="search-container">
//                 <div className="input-group">
//                   <input
//                     type="text"
//                     className="form-control"
//                     placeholder="Search"
//                     aria-label="Search"
//                     value={searchTerm}
//                     onChange={(e) => {
//                       setSearchTerm(e.target.value);
//                       setCurrentPage(1); // Reset to first page when searching
//                     }}
//                   />
//                 </div>
//               </div>
//             </div>

//             {/* Table */}
//             <div className="card tableCard p-2">
//               <div className="table-container">
//                 <table className="table table-layout-fixed w-100">
//                   <thead className="bg-light">
//                     <tr>
//                       <th>S.No</th>
//                       <th>Date</th>
//                       <th>Sales Total</th>
//                       <th>Expense Total</th>
//                       <th>Action</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {currentItems.length > 0 ? (
//                       currentItems.map((item, index) => (
//                         <tr key={index}>
//                           <td>
//                             {(currentPage - 1) * itemsPerPage + index + 1}
//                           </td>
//                           <td>{formatDate(item.date)}</td>
//                           <td>₹ {item.sales_total}</td>
//                           <td>₹ {item.expense_total}</td>
//                           <td>
//                             <button
//                               className="btn btn-light btn-sm mx-1"
//                               onClick={() => handleSalesExpense(item.date)}
//                             >
//                               <i className="fa-solid fa-pen-to-square text-primary fs-6"></i>
//                             </button>
//                           </td>
//                         </tr>
//                       ))
//                     ) : (
//                       <tr>
//                         <td colSpan="5" className="text-center">
//                           No data available
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </table>
//               </div>

//               <div className="row">
//                 <div className="col-lg-6">
//                   <p className="text-muted">
//                     Showing{" "}
//                     {showAllItems ? 1 : (currentPage - 1) * itemsPerPage + 1}{" "}
//                     to{" "}
//                     {showAllItems
//                       ? totalItems
//                       : Math.min(currentPage * itemsPerPage, totalItems)}{" "}
//                     of {totalItems} entries
//                   </p>
//                 </div>
//                 <div className="col-lg-6">
//                   <nav aria-label="Page navigation">
//                     <ul className="pagination justify-content-end">
//                       <li
//                         className={`page-item ${
//                           currentPage === 1 ? "disabled" : ""
//                         }`}
//                       >
//                         <button
//                           className="page-link"
//                           onClick={() => handlePageChange(1)}
//                           aria-label="First"
//                         >
//                           <span aria-hidden="true">&laquo;&laquo;</span>
//                         </button>
//                       </li>
//                       <li
//                         className={`page-item ${
//                           currentPage === 1 ? "disabled" : ""
//                         }`}
//                       >
//                         <button
//                           className="page-link"
//                           onClick={() => handlePageChange(currentPage - 1)}
//                           aria-label="Previous"
//                         >
//                           <span aria-hidden="true">&laquo;</span>
//                         </button>
//                       </li>

//                       {renderPageNumbers()}

//                       <li
//                         className={`page-item ${
//                           currentPage === totalPages || totalPages === 0
//                             ? "disabled"
//                             : ""
//                         }`}
//                       >
//                         <button
//                           className="page-link"
//                           onClick={() => handlePageChange(currentPage + 1)}
//                           aria-label="Next"
//                         >
//                           <span aria-hidden="true">&raquo;</span>
//                         </button>
//                       </li>
//                       <li
//                         className={`page-item ${
//                           currentPage === totalPages || totalPages === 0
//                             ? "disabled"
//                             : ""
//                         }`}
//                       >
//                         <button
//                           className="page-link"
//                           onClick={() => handlePageChange(totalPages)}
//                           aria-label="Last"
//                         >
//                           <span aria-hidden="true">&raquo;&raquo;</span>
//                         </button>
//                       </li>
//                     </ul>
//                   </nav>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default SalesExpense;

import axios from "axios";
import { useState, useEffect, useMemo } from "react"; // Added useMemo
import { useNavigate } from "react-router-dom";
import "../../assets/css/Loader.css";
import ApiUrl from "./../Environment/ApiUrl";
import { useToast } from "../Toast/ToastContext";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";

function SalesExpense() {
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [deleteShowModals, setDeleteShowModals] = useState(false);
  const [actionType, setActionType] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [notifications, setNotifications] = useState([]);
  const [selectedRecordId, setSelectedRecordId] = useState(null);
  const [deleteId, setDeleteId] = useState("");
  const [deleteDate, setDeleteDate] = useState("");
  const navigate = useNavigate();
  const toast = useToast();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [showAllItems, setShowAllItems] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  // Fetch notifications
  const fetchNotifications = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/notification.php`);
      setNotifications(response.data?.data || []);
    } catch (error) {
      console.error("Error fetching notifications:", error.message);
      toast.error(
        `Failed to fetch notifications: ${error.message}`,
        3000,
        "topRight"
      );
    }
  };

  // Check notification status
  const checkNotificationStatus = (recordId, buttonValue) => {
    const userId = localStorage.getItem("username");
    return notifications.some(
      (notif) =>
        notif.table_id === recordId.toString() &&
        notif.button_value === buttonValue &&
        notif.status === "accepted" &&
        notif.employe_id === userId &&
        notif.viewed === "false"
    );
  };

  const hasPendingNotification = (recordId, buttonValue) => {
    const userId = localStorage.getItem("username");
    return notifications.some(
      (notif) =>
        notif.table_id === recordId.toString() &&
        notif.button_value === buttonValue &&
        notif.status === "requested" &&
        notif.employe_id === userId &&
        notif.viewed === "false"
    );
  };

  // Handle notification submission
  const handleNotificationSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    if (isSubmitting) return;
    setIsSubmitting(true);

    if (hasPendingNotification(selectedRecordId, actionType)) {
      toast.warning(
        "A pending request for this action already exists!",
        3000,
        "topRight"
      );
      closeNotificationModal();
      return;
    }

    try {
      const userId = localStorage.getItem("username");
      const currentTime = new Date()
        .toISOString()
        .slice(0, 19)
        .replace("T", " ");

      const formData = {
        table_name: "sales_vs_expense",
        table_id: selectedRecordId,
        employe_id: userId || "",
        status: "requested",
        button_value: actionType,
        time: currentTime,
        viewed: "false",
        created_date: currentTime,
        updated_by: userId || "",
        updated_date: currentTime,
      };

      await axios.post(`${ApiUrl}/Api/notification.php`, formData, {
        headers: { "Content-Type": "application/json" },
      });

      toast.success(
        `${actionType} request sent successfully!`,
        3000,
        "topRight"
      );
      closeNotificationModal();
      fetchNotifications();
    } catch (error) {
      console.error("Error submitting notification:", error.message);
      toast.error(
        `Error submitting notification: ${error.message}`,
        3000,
        "topRight"
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  // Modal controls
  const openNotificationModal = (id, action) => {
    setSelectedRecordId(id);
    setActionType(action);
    setShowModal(true);
  };

  const closeNotificationModal = () => {
    setShowModal(false);
    setSelectedRecordId(null);
    setActionType("");
    setIsSubmitting(false);
  };

  const handleCloseModal = () => {
    setDeleteShowModals(false);
    setDeleteId("");
    setDeleteDate("");
  };

  // Fetch data
  const fetchData = async () => {
    try {
      const localRole = localStorage.getItem("role");
      const localUsername = localStorage.getItem("username");
      const response = await axios.get(
        localRole === "Employee"
          ? `${ApiUrl}/Api/sales_vs_expense.php?employee_id=${localUsername}`
          : `${ApiUrl}/Api/sales_vs_expense.php`
      );
      setResponseData([...(response.data?.data || [])].reverse());
    } catch (error) {
      console.error("Error fetching data:", error.message);
      setResponseData([]);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      }, 100);
    }
  };

  // Format date
  const formatDate = (dateString) => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return dateString;
      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();
      return `${day}-${month}-${year}`;
    } catch (error) {
      return dateString;
    }
  };

  // Handle edit action
  const handleEdit = (id, date) => {
    const userRole = localStorage.getItem("role");
    if (userRole === "Employee") {
      if (checkNotificationStatus(id, "Edit")) {
        navigate(`/add-sales-vs-expense/${date}`);
      } else {
        openNotificationModal(id, "Edit");
      }
    } else {
      navigate(`/add-sales-vs-expense/${date}`);
    }
  };

  // Handle delete action
  const handleOpenDeleteModal = (id, date) => {
    const userRole = localStorage.getItem("role");
    if (userRole === "Employee") {
      if (checkNotificationStatus(id, "Delete")) {
        setDeleteId(id);
        setDeleteDate(formatDate(date));
        setDeleteShowModals(true);
      } else {
        openNotificationModal(id, "Delete");
      }
    } else {
      setDeleteId(id);
      setDeleteDate(formatDate(date));
      setDeleteShowModals(true);
    }
  };

  const handleDelete = async () => {
    try {
      setLoading(true);
      const response = await axios.delete(
        `${ApiUrl}/Api/sales_vs_expense.php/${deleteId}`
      );
      if (response.data.status) {
        const notification = notifications.find(
          (notif) =>
            notif.table_id === deleteId.toString() &&
            notif.button_value === "Delete" &&
            notif.viewed === "false"
        );
        if (notification) {
          const currentTime = new Date()
            .toISOString()
            .slice(0, 19)
            .replace("T", " ");
          const notificationPayload = {
            id: notification.id,
            viewed: "true",
            updated_by: localStorage.getItem("username"),
            updated_date: currentTime,
            table_name: notification.table_name,
            table_id: notification.table_id,
            employe_id: notification.employe_id,
            status: notification.status,
            button_value: notification.button_value,
            time: notification.time,
            created_date: notification.created_date,
          };

          await axios.put(
            `${ApiUrl}/Api/notification.php/${notification.id}`,
            notificationPayload,
            {
              headers: { "Content-Type": "application/json" },
            }
          );
        }

        toast.success("Deleted successfully!", 3000, "topRight");
        handleCloseModal();
        fetchData();
        fetchNotifications();
      } else {
        toast.error(response.data.message, 3000, "topRight");
      }
    } catch (error) {
      console.error("Error deleting data:", error.message);
      toast.error(`Failed to delete data: ${error.message}`, 3000, "topRight");
    } finally {
      setLoading(false);
    }
  };

  // Memoized filtered data
  const filteredData = useMemo(() => {
    return responseData.filter((item) => {
      const searchLower = searchTerm.toLowerCase();
      return (
        (item.date &&
          formatDate(item.date).toLowerCase().includes(searchLower)) ||
        (item.sales_total &&
          item.sales_total.toString().toLowerCase().includes(searchLower)) ||
        (item.expense_total &&
          item.expense_total.toString().toLowerCase().includes(searchLower))
      );
    });
  }, [responseData, searchTerm]);

  // Memoized pagination calculations
  const { totalItems, totalPages, currentItems } = useMemo(() => {
    const totalItems = filteredData.length;
    const totalPages = showAllItems ? 1 : Math.ceil(totalItems / itemsPerPage);
    const currentItems = showAllItems
      ? filteredData
      : filteredData.slice(
          (currentPage - 1) * itemsPerPage,
          currentPage * itemsPerPage
        );

    return { totalItems, totalPages, currentItems };
  }, [filteredData, showAllItems, currentPage, itemsPerPage]);

  const handlePageChange = (page) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  const handleItemsPerPageChange = (e) => {
    const value = e.target.value;
    if (value === "All") {
      setShowAllItems(true);
      setCurrentPage(1);
    } else {
      setShowAllItems(false);
      setItemsPerPage(Number(value));
      setCurrentPage(1);
    }
  };

  const renderPageNumbers = () => {
    const pages = [];
    const maxVisiblePages = 2;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage + 1 < maxVisiblePages) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    if (startPage > 1) {
      pages.push(
        <li
          key={1}
          className={`page-item ${currentPage === 1 ? "active" : ""}`}
        >
          <button
            className="page-link"
            onClick={() => handlePageChange(1)}
            aria-label="First page"
          >
            1
          </button>
        </li>
      );
      if (startPage > 2) {
        pages.push(
          <li key="start-ellipsis" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(
        <li
          key={i}
          className={`page-item ${currentPage === i ? "active" : ""}`}
        >
          <button className="page-link" onClick={() => handlePageChange(i)}>
            {i}
          </button>
        </li>
      );
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pages.push(
          <li key="end-ellipsis" className="page-item disabled">
            <span className="page-link">...</span>
          </li>
        );
      }
      pages.push(
        <li
          key={totalPages}
          className={`page-item ${currentPage === totalPages ? "active" : ""}`}
        >
          <button
            className="page-link"
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </button>
        </li>
      );
    }

    return pages;
  };

  // Export functions
  const handlePrint = () => {
    try {
      const printWindow = window.open("", "_blank");
      printWindow.document.write(`
        <html>
        <head>
          <title>Sales vs Expense Report</title>
          <style>
            body { font-family: Arial, sans-serif; margin: 20px; }
            table { width: 100%; border-collapse: collapse; margin-top: 20px; }
            th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
            th { background-color: #f2f2f2; font-weight: bold; }
            .header { text-align: center; margin-bottom: 20px; }
            .table-secondary { background-color: #e2e3e5; }
            .table-danger { background-color: #f8d7da; }
            .table-info { background-color: #cff4fc; }
          </style>
        </head>
        <body>
          <div class="header"><h2>Sales vs Expense Report</h2></div>
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th>Date</th>
                <th>Sales Total</th>
                <th>Expense Total</th>
              </tr>
            </thead>
            <tbody>
              ${filteredData
                .map((item, index) => {
                  const userId = localStorage.getItem("username");
                  const notification = notifications.find(
                    (notif) =>
                      notif.table_id === item.id.toString() &&
                      notif.employe_id === userId &&
                      notif.viewed === "false" &&
                      ["Edit", "Delete"].includes(notif.button_value)
                  );
                  let rowClass = "";
                  if (notification) {
                    switch (notification.status) {
                      case "accepted":
                        rowClass = "table-secondary";
                        break;
                      case "rejected":
                        rowClass = "table-danger";
                        break;
                      case "requested":
                        rowClass = "table-info";
                        break;
                    }
                  }
                  return `
                  <tr class="${rowClass}">
                    <td>${index + 1}</td>
                    <td>${formatDate(item.date) || ""}</td>
                    <td>₹ ${item.sales_total || "0"}</td>
                    <td>₹ ${item.expense_total || "0"}</td>
                  </tr>
                `;
                })
                .join("")}
            </tbody>
          </table>
        </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
      printWindow.close();
      toast.success("Print dialog opened!", 3000, "topRight");
    } catch (error) {
      console.error("Error printing:", error.message);
      toast.error(`Error printing: ${error.message}`, 3000, "topRight");
    }
  };

  const exportPDF = () => {
    try {
      const doc = new jsPDF();
      doc.setFontSize(20);
      doc.text("Sales vs Expense Report", 14, 22);
      doc.setFontSize(12);
      doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, 35);

      const tableColumn = ["S.No", "Date", "Sales Total", "Expense Total"];
      const tableRows = filteredData.map((item, index) => {
        const userId = localStorage.getItem("username");
        const notification = notifications.find(
          (notif) =>
            notif.table_id === item.id.toString() &&
            notif.employe_id === userId &&
            notif.viewed === "false" &&
            ["Edit", "Delete"].includes(notif.button_value)
        );
        let rowStyle = {};
        if (notification) {
          switch (notification.status) {
            case "accepted":
              rowStyle = { fillColor: [226, 227, 229] };
              break;
            case "rejected":
              rowStyle = { fillColor: [248, 215, 218] };
              break;
            case "requested":
              rowStyle = { fillColor: [207, 244, 252] };
              break;
          }
        }
        return [
          index + 1,
          formatDate(item.date) || "",
          `₹${item.sales_total || "0"}`,
          `₹${item.expense_total || "0"}`,
          rowStyle,
        ];
      });

      autoTable(doc, {
        head: [tableColumn],
        body: tableRows.map((row) => row.slice(0, -1)),
        startY: 45,
        styles: { fontSize: 8, cellPadding: 2 },
        headStyles: { fillColor: [41, 128, 185], textColor: 255 },
        columnStyles: {
          0: { cellWidth: 15 },
          1: { cellWidth: 25 },
          2: { cellWidth: 25 },
          3: { cellWidth: 25 },
        },
        didParseCell: (data) => {
          if (data.section === "body") {
            const rowIndex = data.row.index;
            const rowStyle =
              tableRows[rowIndex][tableRows[rowIndex].length - 1];
            if (rowStyle) {
              data.cell.styles = { ...data.cell.styles, ...rowStyle };
            }
          }
        },
      });

      doc.save(
        `sales-vs-expense-${new Date().toISOString().split("T")[0]}.pdf`
      );
      toast.success("PDF exported successfully!", 3000, "topRight");
    } catch (error) {
      console.error("Error exporting PDF:", error.message);
      toast.error(`Error exporting PDF: ${error.message}`, 3000, "topRight");
    }
  };

  const copyToClipboard = () => {
    try {
      const headers = ["S.No", "Date", "Sales Total", "Expense Total"];
      const rows = filteredData.map((item, index) => [
        index + 1,
        formatDate(item.date) || "",
        item.sales_total || "0",
        item.expense_total || "0",
      ]);

      const formattedText = [headers, ...rows]
        .map((row) => row.map((field) => `"${field}"`).join("\t"))
        .join("\n");

      navigator.clipboard
        .writeText(formattedText)
        .then(() => {
          toast.success(
            "Data copied to clipboard successfully!",
            3000,
            "topRight"
          );
        })
        .catch((err) => {
          console.error("Clipboard API failed:", err);
          toast.error(`Clipboard error: ${err.message}`, 3000, "topRight");
        });
    } catch (error) {
      console.error("Unexpected error copying to clipboard:", error.message);
      toast.error(`Error copying data: ${error.message}`, 3000, "topRight");
    }
  };

  const exportCSV = () => {
    try {
      const csvData = [
        ["S.No", "Date", "Sales Total", "Expense Total"],
        ...filteredData.map((item, index) => [
          index + 1,
          formatDate(item.date) || "",
          item.sales_total || "0",
          item.expense_total || "0",
        ]),
      ];

      const csvContent = csvData
        .map((row) => row.map((field) => `"${field}"`).join(","))
        .join("\n");

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);
      link.setAttribute("href", url);
      link.setAttribute(
        "download",
        `sales-vs-expense-${new Date().toISOString().split("T")[0]}.csv`
      );
      link.style.visibility = "hidden";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      toast.success("CSV file exported successfully!", 3000, "topRight");
    } catch (error) {
      console.error("Error exporting CSV:", error.message);
      toast.error(`Error exporting CSV: ${error.message}`, 3000, "topRight");
    }
  };

  const exportExcel = () => {
    try {
      const excelData = filteredData.map((item, index) => ({
        "S.No": index + 1,
        Date: formatDate(item.date) || "",
        "Sales Total": item.sales_total || "0",
        "Expense Total": item.expense_total || "0",
      }));

      const ws = XLSX.utils.json_to_sheet(excelData);
      const colWidths = [{ wch: 8 }, { wch: 15 }, { wch: 15 }, { wch: 15 }];
      ws["!cols"] = colWidths;
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sales vs Expense");
      XLSX.writeFile(
        wb,
        `sales-vs-expense-${new Date().toISOString().split("T")[0]}.xlsx`
      );
      toast.success("Excel file exported successfully!", 3000, "topRight");
    } catch (error) {
      console.error("Error exporting Excel:", error.message);
      toast.error(`Error exporting Excel: ${error.message}`, 3000, "topRight");
    }
  };

  useEffect(() => {
    fetchData();
    fetchNotifications();

    const interval = setInterval(() => {
      if (document.visibilityState === "visible") {
        fetchData();
        fetchNotifications();
      }
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      {loading && (
        <div className="loading-overlay">
          <div className="loading-message">
            <div className="loadinggif"></div>
          </div>
        </div>
      )}
      <div className="container-fluid">
        <h6 className="card-title m-2">Sales Vs Expense</h6>
        <div className="card shadow-sm mb-5">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="d-flex align-items-center">
                <label className="form-label text-dark me-2">Show:</label>
                <select
                  className="form-control"
                  style={{ width: "100px" }}
                  onChange={handleItemsPerPageChange}
                  value={showAllItems ? "All" : itemsPerPage}
                  aria-label="Items per page"
                >
                  <option value="All">All</option>
                  {[5, 10, 20, 100, 200, 500, 1000].map((pageSize) => (
                    <option key={pageSize} value={pageSize}>
                      {pageSize}
                    </option>
                  ))}
                </select>
              </div>
              <div className="d-flex justify-content-center">
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={handlePrint}
                  aria-label="Print report"
                >
                  Print
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={exportPDF}
                  aria-label="Export to PDF"
                >
                  PDF
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={copyToClipboard}
                  aria-label="Copy to clipboard"
                >
                  Copy
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={exportCSV}
                  aria-label="Export to CSV"
                >
                  CSV
                </button>
                <button
                  className="btn btn-sm btn-info text-white mx-1"
                  onClick={exportExcel}
                  aria-label="Export to Excel"
                >
                  Excel
                </button>
              </div>
              <div className="search-container">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search"
                  aria-label="Search"
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                    setCurrentPage(1);
                  }}
                />
              </div>
            </div>
            <div className="card tableCard p-2">
              <div className="table-container">
                {isLoading ? (
                  <div className="text-center p-4">Loading...</div>
                ) : (
                  <table className="table table-layout-fixed w-100">
                    <thead className="bg-light">
                      <tr>
                        <th scope="col">S.No</th>
                        <th scope="col">Date</th>
                        <th scope="col">Sales Total</th>
                        <th scope="col">Expense Total</th>
                        <th scope="col">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentItems.length > 0 ? (
                        currentItems.map((item, index) => {
                          const userId = localStorage.getItem("username");
                          const notification = notifications.find(
                            (notif) =>
                              notif.table_id === item.id.toString() &&
                              notif.employe_id === userId &&
                              notif.viewed === "false" &&
                              ["Edit", "Delete"].includes(notif.button_value)
                          );

                          let rowClass = "";
                          if (notification) {
                            switch (notification.status) {
                              case "accepted":
                                rowClass = "table-secondary";
                                break;
                              case "rejected":
                                rowClass = "table-danger";
                                break;
                              case "requested":
                                rowClass = "table-info";
                                break;
                            }
                          }

                          return (
                            <tr key={item.id} className={rowClass}>
                              <td>
                                {(currentPage - 1) * itemsPerPage + index + 1}
                              </td>
                              <td>{formatDate(item.date)}</td>
                              <td>₹ {item.sales_total || "0"}</td>
                              <td>₹ {item.expense_total || "0"}</td>
                              <td>
                                <button
                                  className="btn btn-light btn-sm mx-1"
                                  onClick={() => handleEdit(item.id, item.date)}
                                  aria-label={`Edit record for ${formatDate(
                                    item.date
                                  )}`}
                                >
                                  <i className="fa-solid fa-pen-to-square text-primary fs-6"></i>
                                </button>
                                {/* <button
                                  className="btn btn-light btn-sm"
                                  onClick={() =>
                                    handleOpenDeleteModal(item.id, item.date)
                                  }
                                  aria-label={`Delete record for ${formatDate(
                                    item.date
                                  )}`}
                                >
                                  <i className="fa-solid fa-trash text-danger fs-6"></i>
                                </button> */}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="5" className="text-center">
                            No data available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                )}
              </div>
              <div className="row mt-3">
                <div className="col-lg-6">
                  <p className="text-muted">
                    Showing{" "}
                    {showAllItems ? 1 : (currentPage - 1) * itemsPerPage + 1} to{" "}
                    {showAllItems
                      ? totalItems
                      : Math.min(currentPage * itemsPerPage, totalItems)}{" "}
                    of {totalItems} entries
                  </p>
                </div>
                <div className="col-lg-6">
                  <nav aria-label="Page navigation">
                    <ul className="pagination justify-content-end">
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(1)}
                          aria-label="First page"
                        >
                          <span aria-hidden="true">««</span>
                        </button>
                      </li>
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage - 1)}
                          aria-label="Previous page"
                        >
                          <span aria-hidden="true">«</span>
                        </button>
                      </li>
                      {renderPageNumbers()}
                      <li
                        className={`page-item ${
                          currentPage === totalPages || totalPages === 0
                            ? "disabled"
                            : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(currentPage + 1)}
                          aria-label="Next page"
                        >
                          <span aria-hidden="true">»</span>
                        </button>
                      </li>
                      <li
                        className={`page-item ${
                          currentPage === totalPages || totalPages === 0
                            ? "disabled"
                            : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => handlePageChange(totalPages)}
                          aria-label="Last page"
                        >
                          <span aria-hidden="true">»»</span>
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Notification Modal */}
      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        style={{ display: showModal ? "block" : "none" }}
        tabIndex="-1"
        aria-labelledby="notificationModalLabel"
        aria-hidden={!showModal}
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h6
                className="modal-title text-primary"
                id="notificationModalLabel"
              >
                Send {actionType} Request to Admin
              </h6>
              <button
                type="button"
                className="btn-close"
                onClick={closeNotificationModal}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <form onSubmit={handleNotificationSubmit}>
                <p className="text-center">
                  Do you want to request to {actionType.toLowerCase()} this
                  record?
                </p>
                <div className="text-center mt-4">
                  <button
                    type="button"
                    className="btn btn-secondary btn-sm px-4 me-2"
                    onClick={closeNotificationModal}
                    aria-label="Cancel"
                  >
                    No
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary btn-sm px-4"
                    disabled={isSubmitting}
                    aria-label="Submit request"
                  >
                    Yes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* Delete Confirmation Modal */}
      <div
        className={`modal fade ${deleteShowModals ? "show" : ""}`}
        style={{ display: deleteShowModals ? "block" : "none" }}
        tabIndex="-1"
        aria-labelledby="deleteConfirmModalLabel"
        aria-hidden={!deleteShowModals}
        role="dialog"
      >
        <div className="modal-dialog modal-dialog-centered modal-confirm">
          <div className="modal-content">
            <div className="modal-body text-center">
              <div className="d-flex justify-content-center mb-3">
                <div
                  className="icon-box d-flex justify-content-center align-items-center bg-light rounded-circle"
                  style={{ width: "80px", height: "80px" }}
                >
                  <i className="bi bi-exclamation-triangle text-danger fs-2"></i>
                </div>
              </div>
              <h4 className="modal-title mb-3">Are you sure?</h4>
              <h6 className="mb-4">
                Do you really want to delete the record for
                <span className="text-primary"> {deleteDate}</span>?
              </h6>
              <div className="d-flex btn-group">
                <button
                  type="button"
                  className="btn btn-secondary btn-sm flex-grow-1"
                  onClick={handleCloseModal}
                  aria-label="Cancel"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-danger btn-sm flex-grow-1 mx-2"
                  onClick={handleDelete}
                  aria-label="Delete"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SalesExpense;
